import type { SVGProps } from 'react';
export const Checkout = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 5.29c-.47 0-.92.17-1.26.49q-.25.25-.38.55h3.28q-.14-.31-.38-.55c-.34-.32-.79-.5-1.26-.5m3.06 1.04a3 3 0 0 0-.85-1.46A3.2 3.2 0 0 0 10 4c-.83 0-1.63.31-2.21.87q-.65.62-.85 1.46H4.17a1.2 1.2 0 0 0-.88.37 1.1 1.1 0 0 0-.28.86l.87 7.45v.01q.05.42.39.7.32.28.77.28h9.92q.45 0 .77-.28.34-.28.39-.7L17 7.56a1 1 0 0 0-.28-.86 1.2 1.2 0 0 0-.87-.37zm-1.28 1.29v1.22c0 .35.3.64.67.64s.68-.29.68-.64V7.62h2.5l-.84 7.1H5.21l-.83-7.1h2.49v1.22c0 .35.3.64.68.64.37 0 .67-.29.67-.64V7.62z"
      clipRule="evenodd"
    />
  </svg>
);
